import { Component } from "react"
import PropTypes from "prop-types"
import _map from "lodash/map"

export default class EndpointTestCaseMessage extends Component {
  constructor(props) {
    super(props)
    this.messageDetail = this.messageDetail.bind(this)
  }

  messageDetail(field) {
    let detail = null
    const className = "message-detail"
    if (field === "headers") {
      detail = (
        <ul className={className}>
          {_map(this.props.message[field], (val, key) => (
            <li key={key}>
              {key}: {val}
            </li>
          ))}
        </ul>
      )
    } else if (field === "body") {
      let body = this.props.message[field]
      if (typeof body === "object") {
        detail = (
          <pre className={className}>{JSON.stringify(body, null, 2)}</pre>
        )
      } else if (typeof body === "string") {
        try {
          body = JSON.parse(body)
          detail = (
            <pre className={className}>{JSON.stringify(body, null, 2)}</pre>
          )
        } catch (e) {
          detail = <pre className={className}>{body}</pre>
        }
      }
    } else {
      const fieldValue = this.props.message[field]
      detail = (
        <p className={className}>
          {typeof fieldValue === "string"
            ? fieldValue
            : JSON.stringify(fieldValue)}
        </p>
      )
    }

    return detail
  }

  render() {
    let details = "PENDING"
    if (this.props.message) {
      details = _map(this.props.fieldMappings, fieldMapping => {
        let content = null
        _map(fieldMapping.fieldNames, fieldName => {
          if (this.props.message[fieldName.toLowerCase()]) {
            const title = fieldMapping.title
            content = (
              <section key={title}>
                <h6>{title}</h6>
                <section>{this.messageDetail(fieldName)}</section>
              </section>
            )
          }
        })
        return content
      })
    }
    return (
      <section className={`${this.props.type} test-case-detail`}>
        <h6>{this.props.type}</h6>
        {details}
      </section>
    )
  }
}

EndpointTestCaseMessage.propTypes = {
  fieldMappings: PropTypes.array.isRequired,
  message: PropTypes.object,
  type: PropTypes.string.isRequired,
}

EndpointTestCaseMessage.defaultProps = {
  fieldMappings: [
    { title: "Method", fieldNames: ["method"] },
    { title: "Parameters", fieldNames: ["parameters"] },
    { title: "Query", fieldNames: ["query"] },
    { title: "URL", fieldNames: ["url", "href"] },
    { title: "Status Code", fieldNames: ["status", "statuscode"] },
    { title: "Headers", fieldNames: ["headers"] },
    { title: "Body", fieldNames: ["body"] },
  ],
}
